import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";
import {IResultSchedule} from "../../../models/accounts/schedule.model";
import {EarningsApiResponse, EarningsData} from "../../../models/dashboard/earnings.model";

const API_NOTIFICATION_URL = `${environment.apiUrl}/accounts/schedule/`;

@Injectable({
  providedIn: 'root'
})
export class ScheduleHttpService {
  constructor(private http: HttpClient) {
  }

  filter(
    wheres: { [key: string]: string },
    limit: number = 100,
    offset: number = 0,
    sortField: string = '',
    sortOrder: 'asc' | 'desc' = 'asc'
  ): Observable<IResultSchedule> {
    let params = new HttpParams();


    Object.keys(wheres).forEach((key) => {
      params = params.append(key, wheres[key]);
    });


    params = params.append('offset', offset.toString());
    params = params.append('limit', limit.toString());


    if (sortField) {
      params = params.append('ordering', `${sortOrder === 'desc' ? '-' : ''}${sortField}`);
    }

    return this.http.get<IResultSchedule>(API_NOTIFICATION_URL, {params});
  }
  bonusChartData (
    wheres: { [key: string]: string }
  ): Observable<EarningsData[]> {
    let params = new HttpParams();


    Object.keys(wheres).forEach((key) => {
      params = params.append(key, wheres[key]);
    });

    return this.http.get<EarningsData[]>(`${environment.apiUrl}/accounts/bonus_chart_data/`, {params});
  }

}
